import trust_badge from "../images/databaza/trust_badge.png";
import yellowCherryTomatoes from "../images/databaza/yellowCherryTomatoes.jpg";
import yellowCherryTomatoes1 from "../images/databaza/yellowCherryTomatoes1.jpg";
import orangeCauliflower from "../images/databaza/orangeCauliflower.jpg";
import orangeCauliflower1 from "../images/databaza/orangeCauliflower1.jpg";
import miniPlumTomato from "../images/databaza/miniPlumTomato.jpg";
import miniPlumTomato1 from "../images/databaza/miniPlumTomato1.jpg";
import seedlessWhiteGrape from "../images/databaza/seedlessWhiteGrape.jpg";
import seedlessWhiteGrape1 from "../images/databaza/seedlessWhiteGrape1.jpg";
import pomegranate from "../images/databaza/pomegranate.jpg";
import pomegranate1 from "../images/databaza/pomegranate1.jpg";
import organicOavelOrangeAlmaverde from "../images/databaza/organicOavelOrangeAlmaverde.jpg";
import organicOavelOrangeAlmaverde1 from "../images/databaza/organicOavelOrangeAlmaverde1.jpg";
import freshStrawberries from "../images/databaza/freshStrawberries.jpg";
import freshStrawberries1 from "../images/databaza/freshStrawberries1.jpg";
import freshStrawberries2 from "../images/databaza/freshStrawberries2.jpg";
import freshStrawberries3 from "../images/databaza/freshStrawberries3.jpg";
import ApplesGranny from "../images/databaza/ApplesGranny.jpg";
import ApplesGranny1 from "../images/databaza/ApplesGranny1.jpg";
import ApplesGranny2 from "../images/databaza/ApplesGranny2.jpg";
import OnionAlmaverde from "../images/databaza/OnionAlmaverde.jpg";
import OnionAlmaverde1 from "../images/databaza/OnionAlmaverde1.jpg";
import cabbageAlmaverde from "../images/databaza/cabbageAlmaverde.jpg";
import cabbageAlmaverde1 from "../images/databaza/cabbageAlmaverde1.jpg";
import lemonAlmaverde from "../images/databaza/lemonAlmaverde.jpg";
import lemonAlmaverde1 from "../images/databaza/lemonAlmaverde1.jpg";
import courgettesAlmaverde from "../images/databaza/courgettesAlmaverde.jpg";
import courgettesAlmaverde1 from "../images/databaza/courgettesAlmaverde1.jpg";
import jalapenoGreen from "../images/databaza/jalapenoGreen.jpg";
import jalapenoGreen1 from "../images/databaza/jalapenoGreen1.jpg";
import freshbergamot from "../images/databaza/fresh-bergamot.jpg";
import londonSorbet from "../images/databaza/londonSorbet.jpg";
import londonSorbet1 from "../images/databaza/londonSorbet1.jpg";
import londonSorbet2 from "../images/databaza/londonSorbet2.jpg";
import londonSorbet3 from "../images/databaza/londonSorbet3.jpg";
import estrattoDilimone from "../images/databaza/estrattoDilimone.jpg";
import estrattoDilimone1 from "../images/databaza/estrattoDilimone1.jpg";
import pureaDilime from "../images/databaza/pureaDilime.jpg";
import pureaDilime1 from "../images/databaza/pureaDilime1.jpg";
import pineApple from "../images/databaza/pineApple.jpg";
import pineApple1 from "../images/databaza/pineApple1.jpg";
import estrattoDimelagrana from "../images/databaza/estrattoDimelagrana.jpg";
import naturalAnor from "../images/databaza/naturalAnor.jpg";
import naturalAnor1 from "../images/databaza/naturalAnor1.jpg";
import naturalAnor2 from "../images/databaza/naturalAnor2.jpg";
import PeanutButter from "../images/databaza/PeanutButter.jpg";
import PeanutButter1 from "../images/databaza/PeanutButter1.jpg";
import pinkertonAvocado from "../images/databaza/pinkertonAvocado.jpg";
import pinkertonAvocado1 from "../images/databaza/pinkertonAvocado1.jpg";
import chiquitaBananas from "../images/databaza/chiquitaBananas.jpg";
import chiquitaBananas1 from "../images/databaza/chiquitaBananas1.jpg";
import ButterPista1 from "../images/databaza/ButterPista1.jpg";
import BasilPesto from '../images/databaza/BasilPesto.jpg';
import BasilPesto1 from '../images/databaza/BasilPesto1.jpg';
import BasilPesto2 from '../images/databaza/BasilPesto2.jpg';


let Data = [
  {
    id: 1,
    name: "Cherry Tomatoes",
    img: [yellowCherryTomatoes, yellowCherryTomatoes1],
    from_price: 5.0,
    to_price: 12.0,
    total: {
      one_kg: 12.0,
      half_kg: 9.0,
      half_2_kg: 5.0,
    },
    discounted_price: 11.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 48,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Fruits",
    sold: 12,
    sold_hours: 11,
    available: 59,
    star: 4,
    like: false,
    count: 1,
  },
  {
    id: 2,
    name: "Orange Cauliflower",
    img: [orangeCauliflower, orangeCauliflower1],
    from_price: null,
    to_price: 10.0,
    total: null,
    discount_price: 12.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 66,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Fruits",
    sold: 4,
    sold_hours: 6,
    available: null,
    star: 5,
    like: false,
    count: 1,
  },
  {
    id: 3,
    name: "Plum Tomato",
    img: [miniPlumTomato, miniPlumTomato1],
    from_price: 8.0,
    to_price: 15.0,
    total: {
      one_kg: 15.0,
      half_kg: 11.0,
      half_2_kg: 8.0,
    },
    discount_price: 13.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 31,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Fruits",
    sold: 2,
    sold_hours: 16,
    available: null,
    star: 3,
    like: false,
    count: 1,
  },

  {
    id: 4,
    name: "White Grape",
    img: [seedlessWhiteGrape, seedlessWhiteGrape1],
    from_price: null,
    to_price: 15.0,
    total: null,
    discount_price: 14.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 16,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Fruits",
    sold: 12,
    sold_hours: 13,
    available: null,
    star: 2,
    like: false,
    count: 1,
  },
  {
    id: 5,
    name: "Pomegranate",
    img: [pomegranate, pomegranate1],
    from_price: 3.0,
    to_price: 8.0,
    total: {
      one_kg: 8.0,
      half_kg: 5.0,
      half_2_kg: 3.0,
    },
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 55,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Fruits",
    sold: 2,
    sold_hours: 14,
    available: null,
    star: 4,
    like: false,
    count: 1,
  },
  {
    id: 6,
    name: "Navel Orange",
    img: [organicOavelOrangeAlmaverde, organicOavelOrangeAlmaverde1],
    from_price: null,
    to_price: 16.0,
    total: null,
    discount_price: 20.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 57,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Fruits",
    sold: 4,
    sold_hours: 17,
    available: 87,
    star: 4,
    like: false,
    count: 1,
  },
  {
    id: 7,
    name: "Fresh Strawberries",
    img: [
      freshStrawberries,
      freshStrawberries1,
      freshStrawberries2,
      freshStrawberries3,
    ],
    from_price: null,
    to_price: 10.0,
    total: null,
    discount_price: 20.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 26,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Fruits",
    sold: 7,
    sold_hours: 12,
    available: 84,
    star: 5,
    like: false,
    count: 1,
  },
  {
    id: 8,
    name: "Apples Granny",
    img: [ApplesGranny, ApplesGranny1, ApplesGranny2],
    from_price: null,
    to_price: 14.0,
    total: null,
    discount_price: 20.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 59,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Fruits",
    sold: 9,
    sold_hours: 12,
    available: null,
    star: 4,
    like: false,
    count: 1,
  },
  {
    id: 9,
    name: "Red Onion",
    img: [OnionAlmaverde, OnionAlmaverde1],
    from_price: 6.0,
    to_price: 10.0,
    total: {
      half_kg: 10.0,
      half_2_kg: 6.0,
    },
    discount_price: 14.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 21,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Vegetables",
    sold: 2,
    sold_hours: 11,
    available: null,
    star: 2,
    like: false,
    count: 1,
  },
  {
    id: 10,
    name: "Red Cabbage",
    img: [cabbageAlmaverde, cabbageAlmaverde1],
    from_price: 9.0,
    to_price: 15.0,
    total: {
      half_kg: 15.0,
      half_kg: 9.0,
    },
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 67,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Vegetables",
    sold: 4,
    sold_hours: 8,
    available: null,
    star: 3,
    like: false,
    count: 1,
  },
  {
    id: 11,
    name: "Organic Lemon",
    img: [lemonAlmaverde, lemonAlmaverde1],
    from_price: 11.0,
    to_price: 18.0,
    total: {
      one_kg: 18.0,
      half_kg: 15.0,
      half_kg: 9.0,
    },
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 39,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Vegetables",
    sold: 1,
    sold_hours: 14,
    available: 80,
    star: 5,
    like: false,
    count: 1,
  },
  {
    id: 12,
    name: "Organic Almaverde",
    img: [courgettesAlmaverde, courgettesAlmaverde1],
    from_price: 11.0,
    to_price: 18.0,
    total: {
      one_kg: 18.0,
      half_kg: 11.0,
    },
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 8,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Vegetables",
    sold: 8,
    sold_hours: 8,
    available: null,
    star: 3,
    like: false,
    count: 1,
  },
  {
    id: 13,
    name: "Chili Pepper",
    img: [jalapenoGreen, jalapenoGreen1],
    from_price: 7.0,
    to_price: 10.0,
    total: {
      half_kg: 10.0,
      half_2_kg: 7.0,
    },
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 8,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Vegetables",
    sold: 1,
    sold_hours: 17,
    available: null,
    star: 3,
    like: false,
    count: 1,
  },
  {
    id: 14,
    name: "Orange Cauliflower",
    img: [orangeCauliflower, orangeCauliflower1],
    from_price: null,
    to_price: 10.0,
    total: null,
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 66,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Vegetables",
    sold: 4,
    sold_hours: 6,
    available: null,
    star: 5,
    like: false,
    count: 1,
  },
  {
    id: 15,
    name: "Cherry Tomatoes",
    img: [yellowCherryTomatoes, yellowCherryTomatoes1],
    from_price: 5.0,
    to_price: 12.0,
    total: {
      one_kg: 12.0,
      half_kg: 9.0,
      half_2_kg: 5.0,
    },
    discounted_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 48,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Vegetables",
    sold: 12,
    sold_hours: 11,
    available: 59,
    star: 4,
    like: false,
    count: 1,
  },
  {
    id: 16,
    name: "Fresh Bergamot",
    img: [
      organicOavelOrangeAlmaverde1,
      freshbergamot,
      organicOavelOrangeAlmaverde,
    ],
    from_price: 4.0,
    to_price: 10.0,
    total: {
      one_kg: 10.0,
      half_kg: 7.0,
      half_2_kg: 4.0,
    },
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 57,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Vegetables",
    sold: 4,
    sold_hours: 17,
    available: 87,
    star: 4,
    like: false,
    count: 1,
  },
  {
    id: 17,
    name: "Sorbet Ice Cream",
    img: [londonSorbet, londonSorbet1, londonSorbet2, londonSorbet3],
    from_price: null,
    to_price: 12.0,
    total: null,
    discount_price: 15.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 40,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Milk & Cream",
    sold: 14,
    available: 13,
    sold_hours: 17,
    like: false,
    count: 1,
    star: 5,
  },
  {
    id: 18,
    name: "Ratto Milk",
    img: [estrattoDilimone, estrattoDilimone1],
    from_price: null,
    to_price: 20.0,
    total: null,
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 21,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Milk & Cream",
    sold: 4,
    available: 12,
    sold_hours: 17,
    like: false,
    count: 1,

    star: 3,
  },
  {
    id: 19,
    name: "Purea Lime",
    img: [pureaDilime, pureaDilime1],
    from_price: null,
    to_price: 18.0,
    total: null,
    discount_price: 20.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 55,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Milk & Cream",
    sold: 18,
    sold_hours: 17,
    available: 18,
    like: false,
    count: 1,
    star: 4,
  },
  {
    id: 20,
    name: "Pineapple Slices",
    img: [pineApple, pineApple1],
    from_price: null,
    to_price: 18.0,
    total: null,
    discount_price: 25.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 13,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Milk & Cream",
    sold: 70,
    sold_hours: 17,
    available: 60,
    like: false,
    count: 1,
    star: 5,
  },
  {
    id: 21,
    name: "Lagrana Milk",
    img: [estrattoDimelagrana],
    from_price: null,
    to_price: 12.0,
    total: null,
    discount_price: 17.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 47,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Milk & Cream",
    sold: 4,
    available: 83,
    sold_hours: 6,
    like: false,
    count: 1,
    star: 3,
  },
  {
    id: 22,
    name: "Pomegranate Juice",
    img: [naturalAnor, naturalAnor1, naturalAnor2],
    from_price: null,
    to_price: 16.0,
    total: null,
    discount_price: 18.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 28,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Milk & Cream",
    sold: 18,
    available: null,
    sold_hours: 18,
    like: false,
    count: 1,
    star: 3,
  },
  {
    id: 23,
    name: "Apples Granny",
    img: [ApplesGranny, ApplesGranny1, ApplesGranny2],
    from_price: null,
    to_price: 14.0,
    total: null,
    discount_price: 20.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 59,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Milk & Cream",
    sold: 9,
    sold_hours: 12,
    available: null,
    star: 4,
    like: false,
    count: 1,
  },
  {
    id: 24,
    name: "Peanut Butter",
    img: [PeanutButter, PeanutButter1],
    from_price: null,
    to_price: 10.0,
    total: null,
    discount_price: 12.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 59,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Milk & Cream",
    sold: 20,
    sold_hours: 5,
    available: 87,
    star: 4,
    like: false,
    count: 1,
  },
  {
    id: 25,
    name: "Cherry Tomatoes",
    img: [yellowCherryTomatoes, yellowCherryTomatoes1],
    from_price: 5.0,
    to_price: 12.0,
    total: {
      one_kg: 12.0,
      half_kg: 9.0,
      half_2_kg: 5.0,
    },
    discounted_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 48,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Banana",
    sold: 12,
    sold_hours: 11,
    available: 59,
    star: 4,
    like: false,
    count: 1,
  },
  {
    id: 26,
    name: "Orange Cauliflower",
    img: [orangeCauliflower, orangeCauliflower1],
    from_price: null,
    to_price: 10.0,
    total: null,
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 66,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Banana",
    sold: 4,
    sold_hours: 6,
    available: null,
    star: 5,
    like: false,
    count: 1,
  },
  {
    id: 27,
    name: "Plum Tomato",
    img: [miniPlumTomato, miniPlumTomato1],
    from_price: 8.0,
    to_price: 15.0,
    total: {
      one_kg: 15.0,
      half_kg: 11.0,
      half_2_kg: 8.0,
    },
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 31,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Banana",
    sold: 2,
    sold_hours: 16,
    available: null,
    star: 3,
    like: false,
    count: 1,
  },
  {
    id: 28,
    name: "Pomegranate",
    img: [pomegranate, pomegranate1],
    from_price: 3.0,
    to_price: 8.0,
    total: {
      one_kg: 8.0,
      half_kg: 5.0,
      half_2_kg: 3.0,
    },
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 55,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Banana",
    sold: 2,
    sold_hours: 14,
    available: null,
    star: 4,
    like: false,
    count: 1,
  },
  {
    id: 29,
    name: "Pinkerton Avocado",
    img: [pinkertonAvocado, pinkertonAvocado1],
    from_price: 3.0,
    to_price: 5.0,
    total: {
      one_kg: 5.0,
      half_kg: 3.0,
    },
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 29,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Banana",
    sold: 12,
    sold_hours: 11,
    available: null,
    star: 4,
    like: false,
    count: 1,
  },
  {
    id: 30,
    name: "Bananas",
    img: [chiquitaBananas, chiquitaBananas1],
    from_price: 3.0,
    to_price: 18.0,
    total: null,
    discount_price: 19.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 11,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Banana",
    sold: 10,
    sold_hours: 6,
    available: null,
    star: 4,
    like: false,
    count: 1,
  },
  {
    id: 31,
    name: "Butter Pista",
    img: [ButterPista1],
    from_price: null,
    to_price: 12.0,
    total: null,
    discount_price: 18.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 35,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Banana",
    sold: 4,
    sold_hours: 17,
    available: 98,
    star: 4,
    like: false,
    count: 1,
  },
  {
    id: 32,
    name: "Basil Pesto",
    img: [BasilPesto, BasilPesto1, BasilPesto2],
    from_price: null,
    to_price: 8.0,
    total: null,
    discount_price: 10.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 31,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Banana",
    sold: 14,
    sold_hours: 15,
    available: 67,
    star: 2,
    like: false,
    count: 1,
  },
  {
    id: 33,
    name: "Organic Lemon",
    img: [lemonAlmaverde, lemonAlmaverde1],
    from_price: 11.0,
    to_price: 18.0,
    total: {
      one_kg: 18.0,
      half_kg: 15.0,
      half_kg: 9.0,
    },
    discount_price: 20.0,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 39,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Sea Food",
    sold: 1,
    sold_hours: 14,
    available: 80,
    star: 5,
    like: false,
    count: 1,
  },
  {
    id: 34,
    name: "Violet Cauliflower",
    img: [orangeCauliflower1, orangeCauliflower],
    from_price: null,
    to_price: 10.0,
    total: null,
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 66,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Sea Food",
    sold: 4,
    sold_hours: 6,
    available: null,
    star: 5,
    like: false,
    count: 1,
  },
  {
    id: 35,
    name: "Red Onion",
    img: [OnionAlmaverde, OnionAlmaverde1],
    from_price: 6.0,
    to_price: 10.0,
    total: {
      half_kg: 10.0,
      half_2_kg: 6.0,
    },
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 21,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Sea Food",
    sold: 2,
    sold_hours: 11,
    available: null,
    star: 2,
    like: false,
    count: 1,
  },
  {
    id: 36,
    name: "Red Cabbage",
    img: [cabbageAlmaverde, cabbageAlmaverde1],
    from_price: 9.0,
    to_price: 15.0,
    total: {
      half_kg: 15.0,
      half_kg: 9.0,
    },
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 67,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Sea Food",
    sold: 4,
    sold_hours: 8,
    available: null,
    star: 3,
    like: false,
    count: 1,
  },
  {
    id: 37,
    name: "Organic Lemon",
    img: [lemonAlmaverde, lemonAlmaverde1],
    from_price: 11.0,
    to_price: 18.0,
    total: {
      one_kg: 18.0,
      half_kg: 15.0,
      half_kg: 9.0,
    },
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 39,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Sea Food",
    sold: 1,
    sold_hours: 14,
    available: 80,
    star: 5,
    like: false,
    count: 1,
  },
  {
    id: 38,
    name: "Organic Almaverde",
    img: [courgettesAlmaverde, courgettesAlmaverde1],
    from_price: 11.0,
    to_price: 18.0,
    total: {
      one_kg: 18.0,
      half_kg: 11.0,
    },
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 8,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Sea Food",
    sold: 8,
    sold_hours: 8,
    available: null,
    star: 3,
    like: false,
    count: 1,
  },
  {
    id: 39,
    name: "Orange Cauliflower",
    img: [orangeCauliflower, orangeCauliflower1],
    from_price: null,
    to_price: 10.0,
    total: null,
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 66,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Sea Food",
    sold: 4,
    sold_hours: 6,
    available: null,
    star: 5,
    like: false,
    count: 1,
  },
  {
    id: 40,
    name: "Fresh Bergamot",
    img: [
      organicOavelOrangeAlmaverde1,
      freshbergamot,
      organicOavelOrangeAlmaverde,
    ],
    from_price: 4.0,
    to_price: 10.0,
    total: {
      one_kg: 10.0,
      half_kg: 7.0,
      half_2_kg: 4.0,
    },
    discount_price: null,
    some_about:
      "Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s.",
    views: 57,
    Guaranteed: trust_badge,
    Description:
      "The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    category: "Sea Food",
    sold: 4,
    sold_hours: 17,
    available: 87,
    star: 4,
    like: false,
    count: 1,
  },
];

export default Data;